<template>
  <div class="modal_dim on">
    <!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w50p">
          <div class="modal_head">
            <h1 class="h1">
              <span>자격증 발급(재발급)</span>
            </h1>
          </div>
          <div class="modal_con">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl">
                    <p>시험명</p>
                  </div>
                  <div class="form_in" v-if="data.isBefore > 0">
                    <input type="text" placeholder="시험명을 입력해주세요." v-model="form.certName" />
                    <p class="valid" :class="{ on : !certNameCheck}">시험명을 입력해 주세요.</p>
                  </div>
                  <div class="form_in" v-else>
                    <input type="text" placeholder="시험명을 입력해 주세요" readonly :value="data.name" />
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>이름</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input type="text" placeholder="이름을 입력해 주세요" v-model="form.userName"/>
                      <p class="valid" :class="{ on : $v.form.userName.$error}">이름을 입력해주세요.</p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>휴대폰 번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="number"
                        placeholder="-를 제외하고 입력해 주세요"
                        v-model="form.userPhone"
                      />
                      <p class="valid" :class="{ on : $v.form.userPhone.$error}">휴대폰 번호를 입력해주세요.</p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
              </ul>
              <div class="inform_box center white">
                <div>
                  자격증 발급(재발급) 비용이 발생합니다.<br />
                  아래의 정보로 입금 바랍니다.<br />
                  <ol class="dot">
                    <li class="small grey">
                      <span class="ol_li_txt"
                        >계좌:
                        <span class="color bold"
                          >농협 355-0066-4272-33 ｜ (사)한국외식산업협회</span
                        ></span
                      >
                    </li>
                    <li class="small grey">
                      <span class="ol_li_txt"
                        >발급(재발급)비용:
                        <span class="color bold"
                          >15,000원</span
                        ></span
                      >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="modal_btn">
              <div class="btn_wrap">
                <button class="btn bo grey" @click="$emit('eventClose')">
                  이전으로
                </button>
                <button class="btn" @click="fnApply">자격증 발급 신청</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'modal-exam-certification-reapply-popup',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    },
  },
  computed: {
    userData: function() {
      return this.$store.getters['user/getUserData']
    }
  },
  data() {
    return {
      form: {
        userExaminationNo: -1,
        userName: '',
        userPhone: '',
        count: 1,
        certName: '',
        userId: ''
      },
      certNameCheck: true
    }
  },
  created() {
    if (this.data.isBefore <= 0 ) {
      this.form.userName = this.userData.name
      this.form.userPhone = this.userData.userPhone
    }
  },
  watch: {
    'form.certName': function(val) {
      if (!this.$Util.isEmpty(val)) {
        this.certNameCheck = true
      }
    }
  },
  methods: {
    fnApply: async function() {
      this.$v.$touch()
      this.certNameCheck = true
      if (this.data.isBefore > 0 && this.$Util.isEmpty(this.form.certName)) {
        this.certNameCheck = false
        return false
      }
      if (!this.$Util.isValid(this.$v, this.$el)) return false
      if (!this.$Util.isEmpty(this.data.userExaminationNo)) {
        this.form.userExaminationNo = this.data.userExaminationNo
        this.form.certificateNo = this.data.certificateNo
      }
      this.form.userId = this.userData.userId
      const res = await this.$ManagerSvc.upsertCertificate(this.form)
      if (res.code === 1) {
        alert('접수되었습니다.')
        this.$emit('eventClose')
      }
    }
  },
  validations: {
    form: {
      userName: { required },
      userPhone: { required }
    }
  }
}
</script>

<style scoped></style>
